import { render } from "./LeftContent.vue?vue&type=template&id=2b558287&scoped=true"
import script from "./LeftContent.vue?vue&type=script&lang=js"
export * from "./LeftContent.vue?vue&type=script&lang=js"

import "./LeftContent.vue?vue&type=style&index=0&id=2b558287&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b558287"]])

export default __exports__